import React from 'react'
import styles from './SectionInput.module.scss'
import { SectionInputProps } from './SectionInput.types'
import { Input } from 'components/common'
import cl from 'classnames'

const SectionInputComponent = (props: SectionInputProps) => {
  const {
    label,
    className,
    entity,
    layout = 'vertical',
    ...rest
  } = props

  const isLayoutHorizontal = layout === 'horizontal'

  return (
    <div
      className={cl(styles.container, {
        [styles.horizontal]: isLayoutHorizontal
      }, className)}
    >
      {label &&
        <label>
          <span>
            {label}
            {entity && <span>({entity})</span>}
          </span>
        </label>
      }
      <Input
        size='small'
        className={styles.input}
        {...rest as any}
      />
    </div>
  )
}

const SectionInput = SectionInputComponent
export { SectionInput }
